import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { map, switchMap, takeUntil, tap } from "rxjs/operators";
import { Product } from "src/app/model/price/product";
import { GoldCardBasket } from "src/app/model/savings-plan/gold-card-basket";
import { SavingPlan } from "src/app/model/savings-plan/saving-plan";
import { PriceService } from "../price/price.service";
import { SavingPlansService } from "./saving-plans.service";

@Injectable({
  providedIn: "root",
})
export class MyPackageService implements Resolve<any> {
  constructor(
    private savingPlansService: SavingPlansService,
    private priceService: PriceService
  ) {}

  $destroy = new Subject();
  transferAmount = new BehaviorSubject<number>(0);
  rollAmount = new BehaviorSubject<number>(0);
  amountUsed = new BehaviorSubject<number>(0);
  totalWeight = new BehaviorSubject<number>(0);
  showWithdrawSide = new BehaviorSubject<boolean>(null);
  targetAmountMap = new BehaviorSubject<GoldCardBasket[]>(null);
  targetAmount = new BehaviorSubject<number>(0);
  selectedMyPackage = new BehaviorSubject<SavingPlan>(null);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params["id"];
    return this.savingPlansService.myPackages.pipe(
      takeUntil(this.$destroy),
      map((packageList) => {
        const currentSavinPlan = packageList.find((item) => item.id == id);
        this.selectedMyPackage.next(currentSavinPlan);
        this.totalWeight.next(currentSavinPlan.paidMetalWeights.au);
        this.$destroy.next();
      })
    );
  }

  refreshSelectedMyPackage() {
    return  this.savingPlansService.getSavingsPlanById(
          this.selectedMyPackage.value.id

      ).pipe(   tap((newSavingPlan: SavingPlan) => {
        this.selectedMyPackage.next(newSavingPlan);
        this.totalWeight.next(newSavingPlan.paidMetalWeights.au);
      }))
  }

  getSavingPlanPrices() {
    return this.selectedMyPackage.pipe(
      switchMap((savingPlan: SavingPlan) => {
        if (savingPlan.planType == "TRESOR_GOLD") {
          return this.priceService.getTresorGoldPrices();
        }
        return this.priceService.getProductById(savingPlan.productId).pipe(
          map((product: Product) => {
            return { buyPrice: product.buy, sellPrice: product.sell };
          })
        );
      })
    );
  }

  autoRaise(amount: number, paymentType:string) {
    return this.savingPlansService.buyForGoldCard(
      amount,
      paymentType,
      this.selectedMyPackage.value.id
    );
  }

  transferToWallet() {
    return this.savingPlansService.transferToWallet(
      this.transferAmount.value,
      this.selectedMyPackage.value.id
    ).pipe(tap(savingPlan=>{
      this.totalWeight.next(savingPlan.paidMetalWeights.au);
      this.selectedMyPackage.next(savingPlan);
    }));
  }

  getWithdrawRequestValue() {
    return {
      savingPlanId: this.selectedMyPackage.value.id,
      goldCardObjList: this.targetAmountMap.value.map((item) => {
        return { id: item.goldCard.id, quantity: item.amount };
      }),
    };
  }

  sell(amount: number) {
    const currentSavingPlan = this.selectedMyPackage.value;
    const sellRequest = {
      amount: amount,
      savingsPlanId: this.selectedMyPackage.value.id,
    };

    return this.savingPlansService.sell(
      sellRequest,
      currentSavingPlan.planType == "TRESOR_GOLD"
    );
  }

  sellFinishedSavingPlan(savingsPlanId: string) {
    return this.savingPlansService.sell({ savingsPlanId }, false);
  }

  getSavingPlanShipmentCost(afterPurchaseType) {
    return this.savingPlansService.getSavingPlanShipmentCost(
      this.selectedMyPackage.value.id,
      afterPurchaseType
    );
  }
}
